import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from 'antd';
import { useI18n } from 'components/I18nProvider';
import styles from './style.module.scss';
export const LanguageSelect = ({ language, onLanguageChange, segment, loading = false, testId }) => {
    const { intl } = useI18n();
    return (_jsx(Select, { "test-id": testId, className: styles.langSelect, popupClassName: styles.langSelectPopup, getPopupContainer: (triggerNode) => triggerNode.parentElement, value: language, loading: loading, onChange: onLanguageChange, options: [
            {
                key: segment.audioLanguage,
                value: segment.audioLanguage,
                label: `${intl.formatMessage({ id: segment.audioLanguage })} (${intl.formatMessage({ id: 'original' })})`,
                className: styles.langSelectOption,
            },
            ...segment.translationSetup.languages.map((languageSetup) => ({
                key: languageSetup.iso,
                value: languageSetup.iso,
                label: `${intl.formatMessage({ id: languageSetup.iso })} (${intl.formatMessage({ id: 'translated' })})`,
                className: styles.langSelectOption,
            })),
        ] }));
};
export default LanguageSelect;
